import { render } from "./AuthMethodSelection.vue?vue&type=template&id=620a5fe4&scoped=true"
import script from "./AuthMethodSelection.vue?vue&type=script&lang=js"
export * from "./AuthMethodSelection.vue?vue&type=script&lang=js"

import "./AuthMethodSelection.vue?vue&type=style&index=0&id=620a5fe4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-620a5fe4"]])

export default __exports__